import * as core from "@twiage/core";
import * as utils from "@twiage/utils";
import type { KyResponse } from "ky";

import type { HTTPError400Handler } from "./types/HTTPError400Handler";

const httpError400HandlerLog = utils.log("HTTP_ERROR_400_HANDLER");

export const makeHTTPError400Handler =
  (): HTTPError400Handler =>
  async ({ response }: { response: KyResponse }) => {
    const { message } = await response.json<{ message: string }>();

    httpError400HandlerLog.warn("400 Bad Request", message);

    throw new core.CoreError(message, {});
  };
